<app-card [config]="statusConfig">
  <ng-container [formGroup]="formGroup">
    <div class="row">
      <div class="cell">
        <span class="label">{{'common.card.status.actif' | translate}}</span>
      </div>
      <div class="cell">
        <app-switch class="flex-justify-right" formControlName="actif"></app-switch>
      </div>
    </div>
  </ng-container>
</app-card>
